/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Reference to a partner, which has the role policyholder.   (bipro-partner::Vertragspartner)
 */
export interface Policyholder {
  /**
   * Unique identification of a partner within the scope of the request/response object.   Every partner object must define a partner ID.   Every partner role may reference a corresponding partner object.   Values can be choosen freely, but must be unique in the request/response object.
   */
  partnerId: string;
}
